import {
  Banner,
  BannerLeftAccessoryType,
  BannerStatus,
  BannerVariant,
  Box,
  Button,
  ButtonGroup,
  ButtonLayout,
  ButtonSize,
  ButtonVariant,
  Color,
  Dialog,
  H2,
  P,
  Text,
  TypePreset,
} from "@gocardless/flux-react";

import {
  DocumentVerifierProps,
  VerifierState,
} from "./DocumentVerifierContainer";

import { ToTranslate } from "src/components/i18n";

export const FeedbackDialog = ({
  open,
  setDocumentVerifierState,
}: DocumentVerifierProps) => {
  const uploadDocument = () => null;

  return (
    <>
      <Dialog
        as="div"
        open={open}
        closeAction={{
          label: "Close",
          onClose: () => setDocumentVerifierState(null),
          position: "absolute",
        }}
        header={{
          content: (
            <>
              <H2 preset={TypePreset.Heading_02}>
                <ToTranslate>Warning</ToTranslate>
              </H2>
            </>
          ),
          gutterH: 1.5,
        }}
        footer={{
          content: (
            <ButtonGroup
              arrangement={["column-center", null, "row-end-reverse"]}
            >
              <Button
                variant={ButtonVariant.PrimaryOnLight}
                size={ButtonSize.Sm}
                layout={[ButtonLayout.Full, null, ButtonLayout.Inline]}
                onClick={() =>
                  setDocumentVerifierState(VerifierState.UploadDocument)
                }
              >
                <ToTranslate>Choose another file</ToTranslate>
              </Button>
              <Button
                variant={ButtonVariant.TextOnLight}
                size={ButtonSize.Sm}
                layout={[ButtonLayout.Full, null, ButtonLayout.Inline]}
                onClick={() => uploadDocument}
              >
                <ToTranslate>Upload this file anyway</ToTranslate>
              </Button>
            </ButtonGroup>
          ),
          gutterH: 3,
          separator: true,
        }}
      >
        <Box>
          <Box spaceBelow={1}>
            <Text preset={TypePreset.Body_01} weight={400}>
              <ToTranslate>
                The document you uploaded has been flagged for the following
                reasons:
              </ToTranslate>
            </Text>
          </Box>
          <Banner
            data-testid="document-feedback-banner"
            variant={BannerVariant.Light}
            leftAccessory={{
              type: BannerLeftAccessoryType.Status,
              status: BannerStatus.Warning,
            }}
            title={<ToTranslate>Problems with your document</ToTranslate>}
          >
            <P>TODO: FEEDBACK</P>
          </Banner>
          <Box spaceAbove={1}>
            <Text color={Color.Greystone_1400}>
              <ToTranslate>
                If you believe that your document meets all the requirements,
                you can still upload it for our team to review.
              </ToTranslate>
            </Text>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
